import script from "./LinksPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./LinksPage.vue?vue&type=script&setup=true&lang=ts"

import "@/assets/styles/links-page.css?vue&type=style&index=0&id=7dcc06c8&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dcc06c8"]])

export default __exports__